import type { ViewFilters } from "../../domain/app-types.ts";
import type { Todo } from "../../domain/entities.ts";

export function isCrossSpace(filters?: ViewFilters): boolean { return filters?.spaceScope === "all" || filters?.spaceScope === "selected"; }
export function rootInView(root: string, filters: ViewFilters): boolean { return filters.spaceScope !== "selected" || !!filters.spaceIds?.includes(root); }
export function matchesCustomFields(task: Todo, filters: ViewFilters): boolean {
  return (filters.customFields || []).every(filter => {
    const actual = task.customFields?.[filter.id]; const present = actual != null && actual !== "";
    if (filter.operator === "set") return present;
    if (filter.operator === "unset") return !present;
    if (!present) return false;
    if (filter.operator === "contains") return String(actual).toLocaleLowerCase().includes(filter.value.toLocaleLowerCase());
    if (filter.operator === "equals") return typeof actual === "number" ? actual === Number(filter.value) : String(actual).toLocaleLowerCase() === filter.value.toLocaleLowerCase();
    if (typeof actual === "number") { const value = Number(filter.value); return Number.isFinite(value) && (filter.operator === "gte" ? actual >= value : actual <= value); }
    if (task.customFieldSchema?.[filter.id]?.kind === "date" && /^\d{4}-\d{2}-\d{2}$/.test(filter.value)) return filter.operator === "gte" ? String(actual) >= filter.value : String(actual) <= filter.value;
    return false;
  });
}
